import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  accent?: 'pickup' | 'delivery' | 'none';
  children: ReactNode;
}

export function Card({ accent = 'none', className, children, ...rest }: CardProps) {
  const ring =
    accent === 'pickup'
      ? 'border-l-4 border-brand-pickup'
      : accent === 'delivery'
        ? 'border-l-4 border-brand-delivery'
        : '';
  return (
    <div className={cn('card', ring, className)} {...rest}>
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('mb-3 flex items-center justify-between', className)} {...rest}>
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('text-lg font-bold', className)} {...rest}>
      {children}
    </div>
  );
}

export function CardBody({ className, children, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('space-y-2', className)} {...rest}>
      {children}
    </div>
  );
}
